import { createAction, props } from '@ngrx/store';
import { UpdateUserSupportingCompanyOpts, UserSupportingCompany } from '@interfaces';

export const getCompaniesSupportedByUser = createAction(
  '[User-Supporting-Company] Get Companies Supported By User',
  props<{ userId: string }>()
);
export const getCompaniesSupportedByUserSuccess = createAction(
  '[User-Supporting-Company] Get Companies Supported By User SUCCESS',
  props<{ companiesSupportedByUser: UserSupportingCompany[] }>()
);
export const getCompaniesSupportedByUserError = createAction(
  '[User-Supporting-Company] Get Companies Supported By User ERROR',
  props<{ errorMessage: string }>()
);

export const getUsersSupportingCompany = createAction(
  '[User-Supporting-Company] Get Users Supporting Company',
  props<{ companyId: string }>()
);
export const getUsersSupportingCompanySuccess = createAction(
  '[User-Supporting-Company] Get Users Supporting Company SUCCESS',
  props<{ usersSupportingCompany: UserSupportingCompany[] }>()
);
export const getUsersSupportingCompanyError = createAction(
  '[User-Supporting-Company] Get Users Supporting Company ERROR',
  props<{ errorMessage: string }>()
);

export const updateSupportingCompanyOfUser = createAction(
  '[User-Supporting-Company] Update Supporting Company Of User',
  props<{ opts: UpdateUserSupportingCompanyOpts }>()
);

export const updateSupportingCompanyOfUserSuccess = createAction(
  '[User-Supporting-Company] Update Supporting Company Of User SUCCESS',
  props<{ userSupportingCompany: UserSupportingCompany }>()
);

export const updateSupportingCompanyOfUserError = createAction(
  '[User-Supporting-Company] Update Supporting Company Of User ERROR',
  props<{ errorMessage: string }>()
);
